import { getSeasonBySlug } from '../../../../../shared/enums';
import KeystoneRunRankingsContent from '../keystoneRunRankingsContent';
import { KeystoneRecentRunRankingsTableFrontpage } from '../../presentational/keystoneRunRankingsElements/KeystoneRecentRunRankingsTableFrontpage';
import { KeystoneRunRankingsTableFrontpage } from '../../presentational/keystoneRunRankingsElements/KeystoneRunRankingsTableFrontpage';
import { t } from 'i18next';
import moment from 'moment';
import _ from 'lodash';
import { SeasonCountdownPane } from './countdownPane';
import apiService from '../../../services/apiService';
import KeystoneActionCreator from '../../../actions/keystoneActionCreator';
import { Col } from '../../../../../../../shared/frontend/components/grid/Col';
import { Row } from '../../../../../../../shared/frontend/components/grid/Row';

export type TMythicPlusRecentRunsPaneProps = {
  enabled: boolean;
  seasonSlug: string;
  region: string;
  realm?: string;
};

export function MythicPlusRecentRunsPane(props: TMythicPlusRecentRunsPaneProps) {
  if (!props.enabled) {
    return null;
  }

  const season = getSeasonBySlug(props.seasonSlug);
  if (!season) {
    return null;
  }

  const isSeasonActive = moment.utc() >= season.starts.us;

  const countdown = !isSeasonActive ? <SeasonCountdownPane season={season} index={2} /> : null;

  return (
    <>
      <div className="slds-m-bottom--small slds-m-top--large">
        <h2 className="rio-text-title--caps text-raiderio">
          <span className="rio-text-title--caps text-raiderio">{t('frontpage:section-header-recent-mplus')}</span>
          <span className="slds-m-left--small slds-text-title--caps text-white">
            {t(`seasons:${season.slug}.name`)} {season.affix && <>({t(`seasons:${season.slug}.affix`)})</>}
          </span>
        </h2>
      </div>

      {isSeasonActive ? (
        <Row gutter={['xx-small', 'xx-small']}>
          <Col size={12} md={6} grow className="slds-is-relative">
            <KeystoneRunRankingsContent
              instanceId={`frontpage:this_week:${props.region}:${props.realm || 'all'}`}
              title={t('frontpage:weeks-top-timed-mplus-runs')}
              season={season.slug + '-week-current'}
              dungeon="all"
              region={props.region}
              realm={props.realm || 'all'}
              type="leaderboards-strict"
              limit={5}
              component={KeystoneRunRankingsTableFrontpage}
              columns={{
                rank: true,
                time: false,
                tank: true,
                healer: true,
                dps: true,
                faction: false,
                dungeon: true,
                roleIcons: false,
                level: true,
                video: true
              }}
            />
          </Col>
          <Col size={12} md={6} grow className="slds-is-relative">
            <KeystoneRunRankingsContent
              instanceId={`frontpage:recent:${props.region}:${props.realm || 'all'}`}
              title={t('frontpage:recent-timed-mplus-runs')}
              season={season.slug}
              dungeon="all"
              region={props.region}
              realm={props.realm || 'all'}
              type="leaderboards-strict"
              limit={5}
              recent={true}
              component={KeystoneRecentRunRankingsTableFrontpage}
              columns={{
                rank: false,
                time: false,
                tank: true,
                healer: true,
                dps: true,
                faction: false,
                dungeon: true,
                roleIcons: false,
                level: true,
                score: true,
                video: true
              }}
            />
          </Col>
        </Row>
      ) : (
        countdown
      )}
    </>
  );
}

(MythicPlusRecentRunsPane as any).preloadComponentActions = async (
  props: TMythicPlusRecentRunsPaneProps,
  params: any
) => {
  if (!props.enabled) {
    return [];
  }

  return _.flatten(
    await Promise.all(
      [
        { recent: true, affixes: undefined, thisWeek: false },
        { recent: false, affixes: undefined, thisWeek: true }
      ].map(
        (mode: any) =>
          new Promise((resolve: any, reject: any) => {
            const loadParams: any = {
              season: props.seasonSlug + (mode.thisWeek ? '-week-current' : ''),
              dungeon: 'all',
              region: props.region,
              realm: props.realm || 'all',
              strict: true,
              page: 0,
              limit: 5,
              minMythicLevel: 0,
              maxMythicLevel: 0,
              eventId: 0,
              period: 0,
              faction: '',
              recent: mode.recent,
              affixes: mode.affixes
            };

            apiService.getKeystoneRunRankings(loadParams, (err: any, data: any) => {
              if (err) {
                reject(err);
              } else {
                resolve([
                  KeystoneActionCreator.setKeystoneRankings(
                    mode.thisWeek
                      ? `frontpage:this_week:${props.region}:${loadParams.realm}`
                      : `frontpage:${mode.recent ? 'recent' : `timed:${mode.affixes}`}:${props.region}:${loadParams.realm}`,
                    data.rankings
                  )
                ]);
              }
            });
          })
      )
    )
  );
};
